import { useState, useEffect, useCallback } from "react";
import { fetchSysconfig } from "../../../services/api/sysconfigService";
import { listDevicesFromSysconfig } from "../domain/deviceModel";

/**
 * Hook for loading devices from sysconfig.
 * @param {{ storageAccount: string, microgridName: string, datasetName: string }} params
 * @returns {{ sysconfig: Object|null, devices: import("../types/deviceTypes").Device[], loading: boolean, error: Error|null, reload: () => void }}
 */
export function useDevices({ storageAccount, microgridName, datasetName }) {
  const [sysconfig, setSysconfig] = useState(null);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!storageAccount || !microgridName || !datasetName) return;
    setLoading(true);
    setError(null);
    try {
      const data = await fetchSysconfig({
        storageAccount,
        microgridName,
        datasetName,
      });
      setSysconfig(data);
      setDevices(listDevicesFromSysconfig(data));
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [storageAccount, microgridName, datasetName]);

  useEffect(() => {
    load();
  }, [load]);

  return { sysconfig, devices, loading, error, reload: load };
}
